<template>
	<v-card-text>
		<v-toolbar color="blue" class="white--text">
			<v-icon color="white">business_center</v-icon>
			<v-toolbar-title>Dane podmiotu</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>

		<v-btn v-if="editable" class="mt-3 ml-3" color="primary" dark @click="readOnlyMode = !readOnlyMode">
			<v-icon class="ml-1 mr-3">{{ icon }}</v-icon>
			{{ buttonLabel }}
		</v-btn>
		<div class="ma-4" v-if="allDataFetched">
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Polska nazwa</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="polishName"
						data-vv-as="Polska nazwa"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('organizationDataScope.polishName')"
						v-model="data.polishName"
						v-validate="'required'"
						data-vv-scope="organizationDataScope"
						aria-label="label for polish name">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Angielska nazwa</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="englishName"
						data-vv-as="Angielska nazwa"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('organizationDataScope.englishName')"
						v-model="data.englishName"
						v-validate="'required'"
						data-vv-scope="organizationDataScope"
						aria-label="label for english name">
					</v-text-field>
				</v-flex>
			</v-layout>

			<div class="ma-4">
				<v-layout row>
					<v-flex xs3/>
					<v-flex xs5>
						<div class="text-xs-center"><h3>Osoba uprawniona do reprezentowania podmiotu</h3></div>
					</v-flex>
				</v-layout>
			</div>

			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Imię</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="representativeName"
						data-vv-as="Imię"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('organizationDataScope.representativeName')"
						v-model="data.representativePerson.name"
						v-validate="'required'"
						data-vv-scope="organizationDataScope"
						aria-label="label for name">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Nazwisko</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="representativeSurname"
						data-vv-as="Nazwisko"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('organizationDataScope.representativeSurname')"
						v-model="data.representativePerson.surname"
						v-validate="'required'"
						data-vv-scope="organizationDataScope"
						aria-label="label for surname">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Funkcja</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="representativePosition"
						data-vv-as="Funkcja"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('organizationDataScope.representativePosition')"
						v-model="data.representativePerson.position"
						v-validate="'required'"
						data-vv-scope="organizationDataScope"
						aria-label="label for position">
					</v-text-field>
				</v-flex>
			</v-layout>

			<div v-if="!readOnlyMode" class="mt-4">
				<v-layout row>
					<v-flex xs1/>
					<v-flex xs2>
						<v-btn
							@click="handleRepresentativeChosen"
							dark
							color="primary" class="white--text mb-5"
							:disabled="readOnlyMode">
							Druga osoba
							<v-icon class="ml-2 white" v-if="!secondRepresentative">add_circle</v-icon>
							<v-icon class="ml-2 white" v-else>remove_circle</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
			</div>
			<div v-else>
				<v-layout row>
					<v-flex xs3/>
					<v-flex xs5>
						<div class="text-xs-center ma-4"><h3>Druga osoba uprawniona do reprezentowania podmiotu</h3>
						</div>
					</v-flex>
				</v-layout>
				<div v-if="!secondRepresentative">
					<v-layout row>
						<v-flex xs3/>
						<v-flex xs5>
							<div class="text-xs-center"><h3>(Brak)</h3></div>
						</v-flex>
					</v-layout>
				</div>
			</div>

			<v-expand-transition>
				<div v-if="secondRepresentative">
					<v-layout row>
						<v-flex xs1/>
						<v-flex xs2>
							<v-subheader>Imię</v-subheader>
						</v-flex>
						<v-flex xs6>
							<v-text-field
								browser-autocomplete="off"
								data-vv-name="secondRepresentativeName"
								data-vv-as="Imię"
								:readonly="readOnlyMode"
								:error-messages="vErrors.collect('organizationDataScope.secondRepresentativeName')"
								v-model="data.secondRepresentativePerson.name"
								v-validate="'required'"
								data-vv-scope="organizationDataScope"
								aria-label="label for name">
							</v-text-field>
						</v-flex>
					</v-layout>
					<v-layout row>
						<v-flex xs1/>
						<v-flex xs2>
							<v-subheader>Nazwisko</v-subheader>
						</v-flex>
						<v-flex xs6>
							<v-text-field
								browser-autocomplete="off"
								data-vv-name="secondRepresentativeSurname"
								data-vv-as="Nazwisko"
								:readonly="readOnlyMode"
								:error-messages="vErrors.collect('organizationDataScope.secondRepresentativeSurname')"
								v-model="data.secondRepresentativePerson.surname"
								v-validate="'required'"
								data-vv-scope="organizationDataScope"
								aria-label="label for surname">
							</v-text-field>
						</v-flex>
					</v-layout>
					<v-layout row>
						<v-flex xs1/>
						<v-flex xs2>
							<v-subheader>Funkcja</v-subheader>
						</v-flex>
						<v-flex xs6>
							<v-text-field
								browser-autocomplete="off"
								data-vv-name="secondRepresentativePosition"
								data-vv-as="Funkcja"
								:readonly="readOnlyMode"
								:error-messages="vErrors.collect('organizationDataScope.secondRepresentativePosition')"
								v-model="data.secondRepresentativePerson.position"
								v-validate="'required'"
								data-vv-scope="organizationDataScope"
								aria-label="label for position">
							</v-text-field>
						</v-flex>
					</v-layout>
				</div>
			</v-expand-transition>
		</div>
	</v-card-text>
</template>

<script>


	export default {
		name: "OrganizationProfileDataView",

		data() {
			return {
				readOnlyMode: true,

				data: {},

				dataFetched: false,

				secondRepresentative: false,
			};
		},


		methods: {
			handleRepresentativeChosen() {
				this.secondRepresentative = !this.secondRepresentative;

				if (this.secondRepresentative === false) {
					this.data.secondRepresentativePerson.name = "";
					this.data.secondRepresentativePerson.surname = "";
					this.data.secondRepresentativePerson.position = "";
				}
			},

		},

		watch: {
			organizationData: function () {
				this.data = this.organizationData;
				this.secondRepresentative = this.data.secondRepresentativePerson.name !== "";
				this.dataFetched = true;
			},

			readOnlyMode: function (value) {
				if (value) {
					this.$validator.validateAll("organizationDataScope").then(result => {
						if (result) {
							this.$emit("edition-status", !value);
						} else {
							this.readOnlyMode = !this.readOnlyMode;
						}
					});
				} else {
					this.$emit("edition-status", !value);
				}
			},
		},

		computed: {
			icon() {
				return this.readOnlyMode ? "edit" : "save";
			},

			buttonLabel() {
				return this.readOnlyMode ? "Edytuj" : "Skończ edycję";
			},

			allDataFetched() {
				return this.dataFetched;
			},
		},

		props: {
			organizationData: Object,
			editable: {
				default: true,
			},
		},
	};
</script>

<style scoped>

</style>
